import { render } from "./OrganizationsView.vue?vue&type=template&id=7c58cb96&scoped=true&ts=true"
import script from "./OrganizationsView.vue?vue&type=script&lang=ts"
export * from "./OrganizationsView.vue?vue&type=script&lang=ts"

import "./OrganizationsView.vue?vue&type=style&index=0&id=7c58cb96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c58cb96"]])

export default __exports__